import React from 'react';
import './utils/rp-browser';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { loadableReady } from '@loadable/component';
import { createRoot } from 'react-dom/client';

import App from 'app/shared/pages/App';
import MultiAnalyticsModule from 'app/shared/utils/analytics';
import configureStore from 'app/shared/flux/configureStore';
import setupAnalytics from 'app/client/utils/setupAnalytics';
import setupRouting from 'app/client/utils/setupRouting';
import initDatadog from 'app/client/utils/datadog';

const history = createBrowserHistory();

// eslint-disable-next-line no-underscore-dangle
const initialState = window.__INITIAL_STATE__;

const store = configureStore(initialState, history);
const { isProd } = store.getState().app;
window.store = store;
window.browserHistory = history;

// Initialize analytics on client
new MultiAnalyticsModule().init({ isProd }).getMa();
initDatadog({ isProd });

setupAnalytics(store.dispatch);
setupRouting(store.dispatch);

const AppRoot = (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>
);

loadableReady(() => {
  const container = document.getElementById('app-root');
  const root = createRoot(container);

  root.render(AppRoot);
});
